import { twJoin } from 'tailwind-merge';

import { MediaCarousel } from '@/core/tamagoshi/MediaCarousel/MediaCarousel';
import { useFlags } from '@/domains/core/flags/flags.hooks';
import { useUserTiming } from '@/domains/core/observability/utils/useUserTiming';
import { HP_B2C_BLACKFRIDAY_UPPER_PROMO } from '@/domains/proB2BAnimation/featureFlags';
import { CarouselCard } from '@/productDiscovery/CommercialAnimation/components/HomepageCampaigns/CarouselCard/CarouselCard';
import { HomepageSecondaryCampaigns } from '@/productDiscovery/CommercialAnimation/components/HomepageCampaigns/HomepageSecondaryCampaigns/HomepageSecondaryCampaigns';
import { HomepageTertiaryCampaigns } from '@/productDiscovery/CommercialAnimation/components/HomepageCampaigns/HomepageTertiaryCampaigns/HomepageTertiaryCampaigns';
import { useHomepageMain } from '@/productDiscovery/CommercialAnimation/hooks/useHomepageMain';

export const HomepageCampaigns = () => {
  useUserTiming('homepageB2C/HomepageCampaigns');

  const sliderElements = useHomepageMain();

  const [isHPB2CBlackfridayUpperPromo] = useFlags([
    HP_B2C_BLACKFRIDAY_UPPER_PROMO,
  ]);

  return (
    <section
      className={twJoin(
        'mx-auto max-w-[1424px] pb-l desktop:p-l wide:pb-xl',
        isHPB2CBlackfridayUpperPromo && '!pb-0',
      )}
    >
      <div
        className="desktop:flex desktop:flex-row desktop:flex-nowrap
          desktop:items-stretch desktop:justify-between"
      >
        {sliderElements && sliderElements.length !== 0 && (
          <MediaCarousel
            className="desktop:w-[calc(calc(calc(2/3)*100%)-8px)]
              desktop:flex-[0_0_calc(calc(calc(2/3)*100%)-8px)]"
          >
            {sliderElements?.map((slide, index) => (
              <CarouselCard
                element={slide}
                key={`promotion-${slide.name}`}
                loading={index === 0 ? 'eager' : 'lazy'}
                index={index}
              />
            ))}
          </MediaCarousel>
        )}
        <HomepageTertiaryCampaigns
          className="hidden w-[calc(calc(calc(1/3)*100%)-8px)]
            flex-[0_0_calc(calc(calc(1/3)*100%)-8px)] flex-col flex-nowrap
            items-stretch justify-between desktop:flex"
          loading="eager"
        />
      </div>
      <HomepageSecondaryCampaigns />
    </section>
  );
};

HomepageCampaigns.displayName = 'HomepageCampaigns';
